import { render, staticRenderFns } from "./MultipleSchoolSet.vue?vue&type=template&id=5c541289&scoped=true"
import script from "./MultipleSchoolSet.vue?vue&type=script&lang=js"
export * from "./MultipleSchoolSet.vue?vue&type=script&lang=js"
import style0 from "./MultipleSchoolSet.vue?vue&type=style&index=0&id=5c541289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c541289",
  null
  
)

export default component.exports